<template>
  <div>
    <v-dialog v-model="removeDialog" persistent max-width="400">
      <v-card>
        <v-card-title>remove schedule</v-card-title>
        <v-card-text>
          Are you sure you want to permanently remove this schedule from
          <b>{{ selectedDate | myDate }}</b>
          starting from <b>{{ start | myTime }}</b> to
          <b>{{ ends | myTime }} </b>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn small text color="red" v-on="on" @click="closeDialog">
                NO
              </v-btn>
            </template>
            <span>cancel</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn small text color="blue" v-on="on" @click="submit">
                yes
              </v-btn>
            </template>
            <span>Submit</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    removeDialog: Boolean,
    myId: { type: Number, default: 0 },
    medavId: { type: Number, default: 0 },
    selectedDate: { type: String, default: null },
    start: { type: String, default: null },
    ends: { type: String, default: null },
  },
  data: () => ({}),
  created() {},
  methods: {
    closeDialog() {
      let payload = { id: this.myId, state: false };
      this.$emit("closeDelete", payload);
    },
    submit() {
      let medicsAvailableTimesId = parseInt(this.medavId);
      let payload = {
        id: this.myId,
        state: false,
        medic: medicsAvailableTimesId,
      };
      this.$emit("submitDelete", payload);
    },
  },
};
</script>
